module.exports = __webpack_public_path__ + "static/media/cardlogo.3dedc0a8.svg";